import { Grid } from '@material-ui/core'
import { ChatbotConfigurationConversationsView } from '../../views'
import { useTranslation } from 'react-i18next'
import { ModalUtil } from '../../pures'
import { ChatbotService } from '../../../services'

const ChatbotConfigurationConversationsAction = (props) => {
    const { botId, conversations, setConversations } = props
    const { t } = useTranslation()
    const modalUtil = new ModalUtil()

    const url = process.env.REACT_APP_ETICKET_API
    const chatbotService = new ChatbotService(url)

    const createConversation = async (data) => {
        try {
            modalUtil.showModal('loading', t('modal.pure.loading.message'), t('modal.pure.loading.title'))
            const conversation = await chatbotService.createConversation({ botId, ...data })
            setConversations(prev => [...prev, conversation])
            modalUtil.showModal('success', null, t('modal.pure.title.success'))
        } catch (error) {
            modalUtil.showModal('error', error.message, t('modal.pure.title.error'))
        }
    }

    const deleteConversation = async (conversationId) => {
        await modalUtil.showConfirmModal(
            t('modal.pure.title.confirm'),
            t('modal.pure.confirm.delete.conversation'),
            t('modal.pure.button.yes'),
            t('modal.pure.button.no'),
            async () => {
            modalUtil.showModal('loading', t('modal.pure.loading.message'), t('modal.pure.loading.title'))

            try {
                await chatbotService.deleteConversation(conversationId)

                setConversations(prev => prev.filter(conv => conv.id !== conversationId))

                modalUtil.showModal('success', t('modal.pure.success.delete.conversation'), t('modal.pure.title.success'))
            } catch (error) {
                modalUtil.showModal('error', error.message || t('modal.pure.error.delete.conversation'), t('modal.pure.title.error'))
            }
            },
            () => {
            // Opcional: Cancel action
            }
        )
    }

    return (
        <Grid container spacing={2}>
            <ChatbotConfigurationConversationsView
                conversations={conversations}
                createConversation={createConversation}
                deleteConversation={deleteConversation}
            />
        </Grid>
    )
}

export default ChatbotConfigurationConversationsAction